import React from "react";
import { Chart } from "primereact/chart";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Panel } from "primereact/panel";

import ChartDataLabels from 'chartjs-plugin-datalabels';

const options = {
    maintainAspectRatio: false,
    layout: {
        padding: 20
    },
    plugins: {
        legend: {
            display: true,
            position: 'right',
            padding: 20
        },
        datalabels: {
            display: 'auto',
            anchor: 'end',
            align: 'end',
            font: {
                size: 18,
            },
            formatter: (value) => {
                return Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value) + "%"
            },
            color: "#2c3e50"
        },
    }
}

const style = {
    borderWidth: 1,
    padding: 2,
    textAlign: 'center'
}

export default function TabelaParadas({ data, geral, name }) {
    if(!data)
        return null;

    const LegendPlugin = {
        beforeInit(chart, legend, options) {
            const fitValue = chart.legend.fit;
            chart.legend.fit = function () {
                fitValue.bind(chart.legend)();
                return this.height += 50;
            }
        }
    }

    return (
        <div className="p-grid">
            {data[name].map((element, index) => {
                let values = [];
                let total = 0;

                element.paradas.forEach((item) => {
                    let tipo = '';
                    let percentual = 0;
                    if (item.tipo === 'Performance') {
                        tipo = 'Disponibilidade';
                        if(item.values.length > 0) {
                            percentual = item.values[1].percentual
                        }
                    } else {
                        tipo = item.tipo;
                        item.values.forEach((percent) => {
                            percentual += percent.percentual;
                        });
                    }

                    total += percentual;

                    values.push({
                        'tipo': tipo,
                        'percentual': percentual
                    });
                });

                values.push({
                    'tipo': 'Total',
                    'percentual': total
                });

                let chartData = {}
                chartData.labels = [];
                chartData.datasets = [];

                let dataset = {
                    label: 'Paradas',
                    data: [],
                    backgroundColor: [
                        "#63005f",
                        "#3f6900",
                        "#97c1ff",
                        "#890000"
                    ]
                }

                values.forEach((item) => {
                    if (item.tipo !== 'Total') {
                        chartData.labels.push(item.tipo);
                        dataset.data.push(item.percentual);
                    }
                });

                chartData.datasets.push(dataset);

                if (geral && element.nome === 'Total')
                    return null;

                if (geral) {
                    return (
                        <>
                            <div key={`index${index}`} className="p-col-6">
                                {element.paradas.map((tipo, index1) => (
                                    <div key={`parada${index1}`}>
                                        {tipo.tipo === 'Setup' && (
                                            <>
                                                <h4>Turma {element.nome}</h4>
                                                <DataTable
                                                    key={index1}
                                                    size="small"
                                                    tableStyle={{ fontSize: 14 }}
                                                    value={tipo.values}
                                                >
                                                    <Column style={style} alignHeader="center" header={tipo.tipo} field='nome' />
                                                    <Column style={style} alignHeader="center" header="Percentual" field='percentual' body={(rowData) => {
                                                        return Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2 }).format(rowData.percentual) + "%"
                                                    }} />
                                                    <Column style={style} alignHeader="center" header="Tempo" field='tempo' body={(rowData) => {
                                                        return Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2 }).format(rowData.tempo);
                                                    }} />
                                                    <Column style={style} alignHeader="center" header="Qtde" field='quantidade' body={(rowData) => {
                                                        return rowData.quantidade
                                                    }} />
                                                    <Column style={style} alignHeader="center" header="Média" field='media' body={(rowData) => {
                                                        if (parseFloat(rowData.media)) {
                                                            return Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2 }).format(rowData.media);
                                                        } else {
                                                            return "-"
                                                        }
                                                    }} />
                                                </DataTable>
                                            </>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </>
                    )
                }

                return (
                    <Panel
                        className="p-mt-1 p-col-12"
                        collapsed
                        key={`panel${index}`}
                        toggleable
                        header={() => {
                            let text = "Turma ";
                            if (parseInt(element.nome)) {
                                text = "Grupo ";
                            }
                            return <h2 style={{ textAlign: 'center' }}>{element.nome === 'Total' ? 'Total Geral' : text + element.nome}</h2>
                        }}
                    >
                        <div className='p-grid'>
                            {element.paradas.map((tipo, index1) => (
                                <DataTable
                                    className='p-col-4'
                                    key={index1}
                                    size="small"
                                    tableStyle={{ fontSize: 14 }}
                                    value={tipo.values}
                                >
                                    <Column style={style} alignHeader="center" header={tipo.tipo} field='nome' />
                                    <Column style={style} alignHeader="center" header="Percentual" field='percentual' body={(rowData) => {
                                        return Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2 }).format(rowData.percentual) + "%"
                                    }} />
                                    <Column style={style} alignHeader="center" header="Tempo" field='tempo' body={(rowData) => {
                                        return Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2 }).format(rowData.tempo);
                                    }} />
                                    <Column style={style} alignHeader="center" header="Qtde" field='quantidade' body={(rowData) => {
                                        return rowData.quantidade
                                    }} />
                                    <Column style={style} alignHeader="center" header="Média" field='media' body={(rowData) => {
                                        if (parseFloat(rowData.media)) {
                                            return Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2 }).format(rowData.media);
                                        } else {
                                            return "-"
                                        }
                                    }} />
                                </DataTable>
                            ))}
                            <DataTable
                                className="p-col-4"
                                tableStyle={{ fontSize: 14 }}
                                size="small"
                                value={values}
                            >
                                <Column style={style} alignHeader="center" header="Tipo" field="tipo" />
                                <Column style={style} alignHeader="center" header="Percentual" field="percentual" body={(rowData) => {
                                    return Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2 }).format(rowData.percentual) + "%";
                                }} />
                            </DataTable>
                            <div className="p-col-4">
                                <Chart
                                    id="chartParadas"
                                    data={chartData}
                                    height="400px"
                                    options={options}
                                    plugins={[ChartDataLabels, LegendPlugin]}
                                    type="pie"
                                />
                            </div>
                        </div>
                    </Panel>
                )
            })}
            {geral && (
                <div>
                    <h4>Classificação</h4>
                    {[...data[name]].sort((a,b) => { return a.setup - b.setup }).map((element) => {
                        if(element.nome !== 'Total') {
                            return <p><b>Turma {element.nome}:</b> {Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(element.setup)}%</p>
                        }
                        return null;
                    })}
                </div>
            )}
        </div>
    )
}